var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42293",
    "data-name": "Path 42293",
    d: "M53.049,292.672h8.372L59.653,294.4a1.007,1.007,0,0,0,0,1.448,1.066,1.066,0,0,0,1.483,0l3.558-3.476a1.008,1.008,0,0,0,0-1.448l-3.558-3.476a1.066,1.066,0,0,0-1.483,0,1.007,1.007,0,0,0,0,1.448l1.769,1.728H53.049a1.024,1.024,0,1,0,0,2.048",
    transform: "translate(-52.001 -287.148)",
    fill: "#1b2737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIcon);
export default __webpack_public_path__ + "static/media/NavigationIcon.17774f0d7a31892a536429a2bc72e3da.svg";
export { ForwardRef as ReactComponent };